export enum FinderResponseTypes {
    VUE_ITEMS = 'vue-items',
    IDS = 'ids',
}
